export default __webpack_public_path__ + "static/default_news_image-23cf077c700c339a6747432a9a0c41f1.jpg";